import { useIsMobile } from '#src/assets/hooks/useIsMobile.ts'
import { type CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { ActionBar } from '#src/assets/ui/shared/components/ActionBar.tsx'
import { Button } from '#src/assets/ui/shared/components/Button.tsx'
import { uiTokens } from '#src/assets/ui/shared/styles.ts'

export function PreferencesModalFooter({
  t,
  onAcceptAll,
  onAcceptNecessary,
  onSavePreferences,
}: {
  t: CookieConsentTranslator
  onAcceptAll: () => void
  onAcceptNecessary: () => void
  onSavePreferences: () => void
}) {
  const isMobile = useIsMobile()

  return (
    <ActionBar
      isMobile={isMobile}
      padding="16px 24px"
      gap="12px"
      leftGap="8px"
      borderTop={`1px solid ${uiTokens.colors.gray200}`}
      left={
        <>
          <Button variant="primary" type="button" onClick={() => onAcceptAll()}>
            {t('acceptAllBtn')}
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={() => onAcceptNecessary()}
          >
            {t('acceptNecessaryBtn')}
          </Button>
        </>
      }
      right={
        <Button
          type="button"
          variant="secondary"
          onClick={() => onSavePreferences()}
        >
          {t('savePreferencesBtn')}
        </Button>
      }
    />
  )
}
